<template>
    <div class="l-onboard">
        <div class="l-onboard-center">
            <div class="ui centered grid">
                <div class="row">
                    <div class="sixteen wide computer only column">
                        <div class="padding-xl"></div>
                    </div>
                    <div class="sixteen wide center aligned column padding-bottom-md">
                         <router-link to="/"><img src="../assets/images/logo.png" height="40" /></router-link>
                    </div>
                    <div class="eight wide computer fourteen wide tablet sixteen wide mobile column">
                        <h1 class="text-center padding-bottom-lg text-medium">Login</h1>
                        <div class="ui negative message" v-show="loginStatus">
                            {{loginStatusMessage}}
                        </div>
                        <form class="ui form" v-on:submit.prevent="login">
                            <div class="field" id="input-username">
                                <label>Enter Phone Number / Email</label>
                                <div class="ui large input">
                                    <input type="text" placeholder="Enter Phone Number / Email" required v-model="username"/>
                                </div>
                            </div>
                            <div class="field" id="input-password">
                                <label>Enter Password</label>
                                <div class="ui large input">
                                    <input type="password" placeholder="Enter Password" required v-model="password"/>
                                </div>
                            </div>
                            <div class="field">
                                <button id="login" type="submit" class="ui large green fluid button">Login</button>
                            </div>
                            <div class="padding-top-md"></div>
                            <div class="field">
                                <router-link :to="{name: 'forgot'}">Forgot password?</router-link>
                            </div>

                            <div class="padding-md"></div>
                            <div class="field">
                                <router-link :to="{name: 'signup'}" class="ui button">Sign Up</router-link>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import store from "../store";
    import pageFooter from "../components/page-footer";
    import pageHeader from "../components/page-header";
    import alertify from 'alertifyjs';
    export default {
        components: {
            pageFooter, pageHeader
        },
        data:function(){
            return{
                username:'',
                password:'',
                user:'',
                loginStatus: false,
                loginStatusMessage: ''
            }
        },
        methods: {
            login() {
                this.loginStatus = false;
                this.loginStatusMessage = "";
                $("#input-username, #input-password").removeClass("error");
                if(!this.username){
                    $("#input-username").addClass("error");
                    return;
                }
                else if(!this.password){
                    $("#input-password").addClass("error");
                    return;
                }

                $('#login').html('<i class="fas fa-circle-notch fa-spin"></i>');
                var vmLogin = this;

                $.post({
                    url:store.state.rootURLUser+'login/auth',
                    type:"POST",
                    data:JSON.stringify({
                        user_name:this.username,
                        password:btoa(this.password),
                        salt_token: "jhdsjYhg2983k"
                    }),
                    success:function(response,status,jQxhr){
                       // console.log(JSON.stringify(response.data.data));
                         vmLogin.$cookies.set("key",response.data.data.key);
                         vmLogin.$cookies.set("username",window.btoa(vmLogin.username));
                         store.commit("setUserKey",response.data.data.key);
                         if(response.data.data.loginStatus == 2){
                            vmLogin.$router.push({name: 'verify-account'});
                         }
                         else{
                             vmLogin.$router.push({name: 'bulk-dashboard'});
                         }
                         
                    },
                    error:function (jQxhr,status,error) {
                        var statustext = jQxhr.responseJSON.statusDescription;
                        vmLogin.loginStatus = true;
                        $('#login').text('login')
                        if (!statustext) {
                           vmLogin.loginStatusMessage = "An error occurred. Try again later.";
                        }
                        else {
                            vmLogin.loginStatusMessage = statustext;;
                        }
                    }
                });
            },
        },
    }
</script>
